module.exports = __webpack_public_path__ + "img/swiper2.96b1edea.jpg";